var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompressed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(.088 .322)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#ffce6e",
    transform: "translate(-.088 -.322)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#ff462e",
    d: "M186.694 22.177h-6.154v-1.051h.778v-1.577a.38.38 0 0 0 .112.018c.315 0 .57-.412.57-.921s-.255-.92-.57-.92a.382.382 0 0 0-.112.018v-.786h4.6v4.168h.778v1.051zm4.6 4.751V54.5a2.337 2.337 0 0 1-2.337 2.337h-10.17a2.337 2.337 0 0 1-2.337-2.337V26.927a2.331 2.331 0 0 1 .874-1.82.958.958 0 0 1 .67-1.644h11.747a.959.959 0 0 1 .672 1.644 2.327 2.327 0 0 1 .876 1.82zM181.232 23.8h-2.41a.438.438 0 0 0 0 .876h2.41a.438.438 0 0 0 0-.876zm8.691 17.235a.438.438 0 0 0-.876 0v11.972a.438.438 0 0 0 .876 0z",
    transform: "translate(22.531 9.763) translate(-176.45 -16.958)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompressed);
export default __webpack_public_path__ + "static/media/compressed.a750e70beafd1cef380e6ed4d2f66e2d.svg";
export { ForwardRef as ReactComponent };